export function getURLParams(obj: Record<string, unknown>) {
  return Object.keys(obj)
    .map((k) => {
      const value = Reflect.get(obj, k);
      if (value === undefined) return '';
      return encodeURIComponent(k) + '=' + encodeURIComponent(value);
    })
    .join('&');
}

/**
 * @param apiUrl, {string}. e.g. "/ontologies/job_titles/"
 * @param queryParams, {Record<string, unknown>}. e.g. { page: 3, size: 100 }
 * @returns {string}, the api endpoint, e.g. /ontologies/job_titles/?page=3&size=100
 */
export const getApiUrlWithParams = (
  apiUrl: string,
  queryParams?: Record<string, unknown>,
) => {
  if (queryParams) {
    return `${apiUrl}?${getURLParams(queryParams)}`;
  }
  return apiUrl;
};
